// extracted by mini-css-extract-plugin
module.exports = {"logoImg":"SideMenu_logoImg__1gIWP","test":"SideMenu_test__2Ps4k","toggleBtn":"SideMenu_toggleBtn__2HOKc"};